



















import { Component, Mixins } from "vue-property-decorator"
import RiskProfileOptions from "@/components/RiskProfile/RiskProfileOptions.vue"
import { mapState, mapGetters } from "vuex"
import BodyMapMixins from "@/mixins/BodyMapMixins"
import TransitionMixins from "@/mixins/TransitionMixins"

@Component({
  components: {
    RiskProfileOptions,
  },
  computed: {
    ...mapState("RiskProfile", {
      riskProfile: "riskProfile",
      bodyParts: "bodyParts", // is used in BodyMapMixins
    }),
    ...mapState("Business", {
      business: "business",
    }),
    ...mapGetters("RiskProfile", {
      enabledQuestionGroups: "enabledQuestionGroups",
      bodyPartPreviewItems: "bodyPartPreviewItems",
    }),
  },
})
export default class RiskProfileRead extends Mixins(BodyMapMixins, TransitionMixins) {

  // RiskProfile State
  riskProfile!: {
    name: string;
    description: string;
  }

  // Business State
  business!: Model

  // Getters
  enabledQuestionGroups!: []
  bodyPartPreviewItems!: []

  questionGroupDescription = "Here is the list of the question groups the individual will complete which will provide the relevant information in their report."

  // Computed
  get riskProfileVal() {
    return this.riskProfile
  }
  set riskProfileVal(v) {
    this.$store.commit("RiskProfile/SET_RISK_PROFILE", v)
  }

  // BeforeMount
  beforeMount() {
    this.business.object_id = this.$route.params.businessOid

    this.$store.dispatch(
      "RiskProfile/fetchFullStructure",
      this.$route.params.riskProfileOid
    )
  }
}
